module.exports = __webpack_public_path__ + "static/img/ikonaSluchowisko-ON.05cc3e20.png";